import { formalityOptions } from "./constants";

export type FieldId = string;

export type Locale = string | "de" | "en";

export type GlossaryId = string;

export enum INLINES {
    EMBEDDED_ENTRY = "embedded-entry-inline",
    ENTRY_HYPERLINK = "entry-hyperlink",
    ASSET_HYPERLINK = "asset-hyperlink",
}

export type Formality = (typeof formalityOptions)[number]["key"];

export type LabeledLocale = {
    locale: Locale;
    label: string;
};

export type GlossaryLocalePair = {
    source: Locale;
    target: Locale;
};

export type Glossary = {
    id: GlossaryId;
    name: string;
    lastUpdated: string;
    entryCount: number;
    locales: GlossaryLocalePair[];
};

export type AppInstallationParameters = {
    deeplApiKey: string;
    formality: Formality;
    glossaryId?: GlossaryId;
    masked: boolean;
    installedVersion?: string;
};

export type NewFeaturesDialogParameters = {
    version: string;
};

export type NewFeaturesDialogData = {
    stopShowing: boolean;
};

export type TranslatableField = {
    id: string;
    label: string;
};

export type TranslationValue = {
    nodeType: string;
    data: object;
    content: ContentNode[];
};

export interface ContentNode extends Node {
    content: Node[];
}

export interface FetchProps {
    skip?: boolean;
}
